import type { Match } from "@little-finds/core";

export function evidenceAge(
  value: string | null | undefined,
  now = Date.now(),
) {
  if (!value || !Number.isFinite(Date.parse(value))) return "Date unknown";
  const observed = Date.parse(value);
  if (observed > now) return "Future timestamp";
  const hours = (now - observed) / 3600000;
  return hours < 1
    ? `${Math.max(1, Math.floor(hours * 60))}m ago`
    : hours < 24
      ? `${Math.floor(hours)}h ago`
      : new Date(value).toLocaleDateString(undefined, {
          month: "short",
          day: "numeric",
        });
}

/** The card timestamp must describe the same evidence as its status label. */
export function representativeMatch(matches: Match[]): Match | undefined {
  const priority: Record<Match["state"], number> = {
    recent: 0,
    conflicting: 1,
    older: 2,
    mention: 3,
    stockist: 4,
  };
  return [...matches].sort(
    (a, b) =>
      priority[a.state] - priority[b.state] ||
      (Date.parse(b.observed_at ?? "") || 0) -
        (Date.parse(a.observed_at ?? "") || 0),
  )[0];
}
